/*
 * @Author: song 
 * @Date: 2018-02-08 15:34:54 
 * @Last Modified by: song
 * @Last Modified time: 2018-02-08 15:35:28
 */
/* 上传作品 */
export default {
  name: "upload",
  contestants: {
    contestants_01: {
      url: '../data/work_contestants_01_data.json',
    }
  },
};


// WEBPACK FOOTER //
// ./src/projects/huayu/config/dev/uploadproduction.js